import { TOKEN, apiUrl } from "../Constants";
import api from "./ApiService";

const BASE_URL = apiUrl + "/api/employer"

export function getAllEmployer(data: any) {
  return api.get(
    `${BASE_URL}/query?search=${data.search}&status=${data.status}`
  )
}

export function getActiveEmployer() {
  return api.get(`${BASE_URL}/employerActive`)
}

export function getEmployerById(id: string) {
  return api.get(`${BASE_URL}/${id}`)
}

export function createEmployer(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.post(`${BASE_URL}`, data, config)
}

export function updateEmployerData(id: string, data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.post(`${BASE_URL}/edit/${id}`, data, config)
}
